import { render, staticRenderFns } from "./OtherPDSensorsOverview.vue?vue&type=template&id=0cfa577b&scoped=true&lang=pug"
import script from "./OtherPDSensorsOverview.vue?vue&type=script&lang=js"
export * from "./OtherPDSensorsOverview.vue?vue&type=script&lang=js"
import style0 from "./OtherPDSensorsOverview.vue?vue&type=style&index=0&id=0cfa577b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa577b",
  null
  
)

export default component.exports